module.exports = __webpack_public_path__ + "img/social-networker.82d770b7.svg";